"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ContentContainer = _interopRequireDefault(require("../components/rules-list/ContentContainer"));
var _RulesListContainer = _interopRequireDefault(require("../components/rules-list/RulesListContainer"));
var _PageContext = require("../context/PageContext");
var _materialSymbols = require("@design/icons/material-symbols");
var _usePlaybook2 = require("../hooks/usePlaybook");
var _AuthContext = require("../context/AuthContext");
var _PlaybookPageHeader = _interopRequireDefault(require("../components/PlaybookPageHeader"));
var _PlaybookInfoContainer = _interopRequireDefault(require("../components/PlaybookInfoContainer"));
var _filterHeader = require("@common/components/filter-header");
var _PlaybookRuleCard = _interopRequireDefault(require("../components/PlaybookRuleCard"));
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var formatStatus = function formatStatus(status) {
  switch (status) {
    case "active":
      return "Active";
    case "draft":
      return "Draft";
    case "initializing":
      return "Initializing";
    case "archived":
      return "Archived";
    case "deleted":
      return "Deleted";
    case "error":
      return "Error";
  }
};
var getStatusBadgeStyles = function getStatusBadgeStyles(status) {
  switch (status) {
    case "active":
      return {
        backgroundColor: "#ECFDF3",
        color: "#027A48"
      };
    case "draft":
      return {
        backgroundColor: "#FFFAEB",
        color: "#B54708"
      };
    case "initializing":
    case "archived":
    case "deleted":
    case "error":
      return {
        backgroundColor: "#F3F4F6",
        color: "#6B7280"
      };
  }
};
var PlaybookPage = function PlaybookPage(_ref) {
  var _ref$playbookId = _ref.playbookId,
    playbookId = _ref$playbookId === void 0 ? "" : _ref$playbookId;
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage,
    pageParams = _usePage.pageParams;
  var _usePlaybook = (0, _usePlaybook2.usePlaybook)(playbookId),
    playbook = _usePlaybook.playbook,
    loading = _usePlaybook.loading,
    error = _usePlaybook.error;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    user = _useAuthInfo.user;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    categoryFilter = _useState4[0],
    setCategoryFilter = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    importanceFilter = _useState6[0],
    setImportanceFilter = _useState6[1];
  var categories = (0, _react.useMemo)(function () {
    if (!(playbook !== null && playbook !== void 0 && playbook.bySection)) return [];
    return playbook.bySection.map(function (section) {
      return section.name;
    });
  }, [playbook]);
  var ruleFilterSections = [{
    title: "Category",
    options: categories.map(function (category) {
      return {
        label: category,
        value: category
      };
    }),
    selectedValues: categoryFilter,
    onSelectedValuesChange: setCategoryFilter
  }, {
    title: "Risk score",
    options: [{
      label: "High",
      value: "high"
    }, {
      label: "Medium",
      value: "medium"
    }, {
      label: "Low",
      value: "low"
    }, {
      label: "Draft",
      value: "draft"
    }],
    selectedValues: importanceFilter,
    onSelectedValuesChange: setImportanceFilter
  }];
  var filteredCategories = (0, _react.useMemo)(function () {
    if (!(playbook !== null && playbook !== void 0 && playbook.bySection)) return [];
    return playbook.bySection.filter(function (category) {
      if (categoryFilter.length > 0 && !categoryFilter.includes(category.name)) {
        return false;
      }
      return true;
    }).map(function (category) {
      return _objectSpread(_objectSpread({}, category), {}, {
        rules: category.rules.filter(function (rule) {
          if (!(0, _foldedTextSearch.matchesSearch)(rule.name, searchQuery) && !(0, _foldedTextSearch.matchesSearch)(rule.description, searchQuery)) {
            return false;
          }
          if (importanceFilter.length > 0) {
            var _rule$importance;
            var ruleImportance = ((_rule$importance = rule.importance) === null || _rule$importance === void 0 ? void 0 : _rule$importance.toLowerCase()) || "draft";
            if (!importanceFilter.includes(ruleImportance)) {
              return false;
            }
          }
          return true;
        })
      });
    }).filter(function (category) {
      return category.rules.length > 0;
    });
  }, [playbook, searchQuery, categoryFilter, importanceFilter]);
  var handleBackClick = function handleBackClick() {
    var returnTo = pageParams === null || pageParams === void 0 ? void 0 : pageParams.returnPage;
    if (returnTo) {
      showPage(returnTo);
    } else {
      showPage(_PageContext.PAGES.myPlaybooksPage);
    }
  };
  var handleCreateRule = function handleCreateRule() {
    var originalReturnPage = (pageParams === null || pageParams === void 0 ? void 0 : pageParams.returnPage) || _PageContext.PAGES.myPlaybooksPage;
    showPage(_PageContext.PAGES.rulePage, {
      playbookId: playbookId,
      mode: "create",
      returnPage: _PageContext.PAGES.playbookPage,
      originalReturnPage: originalReturnPage
    });
  };
  var handleRuleClick = function handleRuleClick(rule) {
    var canEdit = rule.isManagedRule && (user === null || user === void 0 ? void 0 : user.hasManageManagedRulesPermission) || !rule.isManagedRule && (user === null || user === void 0 ? void 0 : user.hasManageUserRulesPermission);
    var originalReturnPage = (pageParams === null || pageParams === void 0 ? void 0 : pageParams.returnPage) || _PageContext.PAGES.myPlaybooksPage;
    showPage(_PageContext.PAGES.rulePage, {
      playbookId: playbookId,
      ruleId: rule.id,
      mode: canEdit ? "edit" : "view",
      returnPage: _PageContext.PAGES.playbookPage,
      originalReturnPage: originalReturnPage
    });
  };
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentContainer.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RulesListContainer.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "text-[#6B7280] text-sm text-center p-6",
          children: "Loading playbook..."
        })
      })
    });
  }
  if (error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentContainer.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RulesListContainer.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "text-[#DC2626] text-sm text-center p-6 bg-[#FEE2E2] rounded-md border border-[#FCA5A5]",
          children: error
        })
      })
    });
  }
  if (!playbook) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_filterHeader.FilterHeader, {
      searchQuery: searchQuery,
      onSearchQueryChange: setSearchQuery,
      searchPlaceholder: "Search rules\u2026",
      filterSections: ruleFilterSections,
      "data-sentry-element": "FilterHeader",
      "data-sentry-source-file": "PlaybookPage.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentContainer.default, {
      "data-sentry-element": "ContentContainer",
      "data-sentry-source-file": "PlaybookPage.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RulesListContainer.default, {
        "data-sentry-element": "RulesListContainer",
        "data-sentry-source-file": "PlaybookPage.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PlaybookPageHeader.default, {
          playbookName: playbook.name,
          onBackClick: handleBackClick,
          statusBadge: playbook.status ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium",
            style: getStatusBadgeStyles(playbook.status),
            children: formatStatus(playbook.status)
          }) : undefined,
          "data-sentry-element": "PlaybookPageHeader",
          "data-sentry-source-file": "PlaybookPage.tsx"
        }), playbook.description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlaybookInfoContainer.default, {
          description: playbook.description
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "my-1 pb-20",
          children: [filteredCategories.map(function (category) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "mb-4",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
                className: "text-base font-semibold text-[#555555] m-0 mb-1",
                children: category.name
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col gap-2",
                children: category.rules.map(function (rule) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlaybookRuleCard.default, {
                    rule: rule,
                    onClick: handleRuleClick
                  }, rule.id);
                })
              })]
            }, category.name);
          }), filteredCategories.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "text-center p-6 text-[#6B7280]",
            children: "No rules found"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          onClick: handleCreateRule,
          className: "fixed bottom-4 left-0 flex items-center justify-center gap-2 px-2 py-2.5 rounded-r-md text-[13px] transition-all duration-200 ease-in-out shadow-[0_1px_3px_rgba(0,0,0,0.1)] border border-primary bg-primary text-white cursor-pointer z-50 hover:bg-background-primary-hover hover:border-background-primary-hover hover:-translate-y-px hover:shadow-[0_4px_12px_rgba(0,0,0,0.15)] active:translate-y-0 active:shadow-[0_2px_6px_rgba(0,0,0,0.1)] disabled:bg-[#F3F4F6] disabled:text-[#9CA3AF] disabled:border-[#E5E7EB] disabled:cursor-not-allowed disabled:shadow-none",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddIcon, {
            width: 16,
            height: 16,
            "data-sentry-element": "AddIcon",
            "data-sentry-source-file": "PlaybookPage.tsx"
          }), "Create"]
        })]
      })
    })]
  });
};
var _default = exports.default = PlaybookPage;